import * as $ from 'jquery';
import 'trumbowyg/dist/trumbowyg.js';
import 'trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js';
import 'trumbowyg/dist/ui/trumbowyg.css';

$.trumbowyg.svgPath = '/images/icons.svg';
export default(function(){
	$('.trumbowyg').trumbowyg();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/trumbowyg/index.js